/*
 * A tipografia do produto.
 *
 * Duas famílias, com papéis separados - a estratégia que a Voa aplica e que
 * decidimos adotar em 02/09/2026:
 *
 * - **IBM Plex Sans** para tudo que se lê: menu, rótulo, enunciado, botão. É
 *   uma grotesca desenhada para tela, com números tabulares e acentuação
 *   completa para o português;
 * - **IBM Plex Serif** para o que se **anuncia**: preço, número de desempenho,
 *   título de vitrine. Serifa em corpo grande, peso leve e entrelinha apertada
 *   é o que separa uma tela de produto de um painel de administração - e era
 *   exatamente o que faltava nas telas de plano e de assinatura.
 *
 * As duas são da mesma família tipográfica (o IBM Plex), então convivem sem
 * briga de proporção. E as duas são servidas do nosso domínio, pelo
 * `@fontsource`: nada de requisição ao Google em cada carregamento.
 */

/** A família de leitura. Vira o `fontFamily` do tema do Antd. */
export const fontFamilySans =
  "'IBM Plex Sans Variable', 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

/**
 * A família de anúncio. **Não** entra no tema: o Antd tem um `fontFamily` só, e
 * trocá-lo por serifa serifaria a interface inteira. Ela se aplica peça a peça,
 * pelo `estiloDeDestaque`.
 */
export const fontFamilySerif = "'IBM Plex Serif', Georgia, 'Times New Roman', serif";

/**
 * O número em destaque: preço, percentual de acerto, contagem.
 *
 * O aperto negativo é o detalhe que faz a diferença. Serifa em corpo grande com
 * entreletra normal fica frouxa e parece texto de corpo esticado; a -6% ela
 * fecha e vira um bloco - que é como um preço se lê.
 */
export function estiloDeDestaque(tamanho: number, peso: 300 | 400 = 400) {
  return {
    fontFamily: fontFamilySerif,
    fontSize: tamanho,
    fontWeight: peso,
    letterSpacing: `${(tamanho * -0.06).toFixed(2)}px`,
    lineHeight: 1.1,
    // O preço tem que alinhar com o preço do cartão vizinho, e o dígito 1 da
    // serifa é mais estreito que os outros.
    fontVariantNumeric: 'tabular-nums' as const,
  };
}
